import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './InputTextAreaField.scss'

export default class InputTextAreaField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    fieldName: PropTypes.string,
    fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    required: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    fieldOnlyBoolean: PropTypes.bool,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="group">
        {!this.props.fieldOnlyBoolean ? (
          <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor={this.props.fieldName}>
            {this.props.name ? this.props.name : null}
            {this.props.required ? '*' : null}
          </label>
        ) : null}
        <div className="input-wrapper">
          <textarea
            className={`input-field input-textarea ${this.props.error ? 'error' : ''}`}
            value={this.props.fieldValue}
            onChange={this.handleChange}
            id={this.props.fieldName}
            disabled={this.props.readOnly}
          />
        </div>
      </div>
    )
  }

  handleChange = event => {
    this.props.onChange(event.target.value, this.props.fieldName)
  }
}
